import { eachDayOfInterval, startOfMonth, subDays } from 'date-fns';

/** How far back a staff retro entry may start — mirrors the backend guard
 * (`RETRO_ENTRY_MAX_DAYS_PAST` in assignment_service.py). */
export const RETRO_ENTRY_MAX_DAYS_PAST = 30;

const startOfToday = (): Date => {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
};

/**
 * Days painted disabled on the create calendar. Non-retro preserves the
 * long-standing behavior (past days of the current month); with retro
 * enabled nothing is disabled here — the fromDate boundary below owns the
 * RETRO_ENTRY_MAX_DAYS_PAST cutoff, so days between the cutoff and today
 * become selectable.
 */
export function getDisabledPastDates(retroEnabled: boolean, today: Date = startOfToday()): Date[] {
  if (retroEnabled) return [];
  if (today.getDate() <= 1) return [];
  return eachDayOfInterval({ start: startOfMonth(today), end: subDays(today, 1) });
}

/**
 * Earliest selectable/navigable date for BaseCalendar's fromDate prop.
 * `undefined` falls through to BaseCalendar's default (start of the current
 * month). With retro enabled the boundary reaches back RETRO_ENTRY_MAX_DAYS_PAST
 * days, crossing into the previous month when the window spans it.
 */
export function getCalendarFromDate(
  retroEnabled: boolean,
  today: Date = startOfToday()
): Date | undefined {
  if (!retroEnabled) return undefined;
  return subDays(today, RETRO_ENTRY_MAX_DAYS_PAST);
}
